import type { CSSProperties, FC, ReactNode } from 'react';
import { PDF_BORDER } from '../constants';

type Props = {
  children: ReactNode;
  style?: CSSProperties;
  colSpan?: number;
  rowSpan?: number;
};

export const ReportTd: FC<Props> = ({
  children,
  style,
  colSpan = 1,
  rowSpan,
}) => {
  return (
    <td
      colSpan={colSpan}
      rowSpan={rowSpan}
      style={{
        padding: 0,
        borderLeft: PDF_BORDER.NORMAL,
        borderRight: PDF_BORDER.NORMAL,
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {children}
    </td>
  );
};
